// @ts-nocheck

import config from '../config/app.config';
import { getLang } from '../i18n/l10n';

export const getImagePath = (img: string | null) => {
  if (img) {
    if (img[0] === '/') {
      return `${config.webHost[getLang()]}/${img}`;
    }
    return img;
  }

  return null;
};
